import { Injectable } from "@angular/core";
import { ApiEsService } from "./api-es.service";

@Injectable({
    providedIn: "root",
})
export class ProductEsService {
    constructor(private apiEsService: ApiEsService) {}

    public getProduct(args: any) {
        return this.apiEsService.callServicePostToCollection("solar.services.product.getProduct", args, null, false);
    }

    public getAdditionalProduct(args: any) {
        return this.apiEsService.callServicePostToCollection("solar.services.product.getProductAdditional", args, null, false);
    }
}
